import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const BroadcastDescription = props => {
	const {
		description,
		descriptionRef,
		showFullDescription,
		toggleDescription,
		isMoreThanTwoLines,
		hideSeeBtn
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.descContainer }>
			<div ref = { descriptionRef }>
				<Typography
					className = { showFullDescription ?
						 classes.fullDescriptionBroadcast :
						  classes.descriptionBroadcast }
					color   = "secondary"
					linkify = { true }
					size    = { "sm" }
					title   = { description }
				/>
			</div>

			{!hideSeeBtn && (
				<Typography
					className = { classes.seeBtn }
					onClick   = { toggleDescription }
					size      = { "sm" }
					title     = { showFullDescription ? "See Less" : "See More" }
				/>
			)}

			{/* {
				!showFullDescription && isMoreThanTwoLines && !hideSeeBtn && (
					<Typography
						className = "fontWeightBold"
						color     = "secondary"
						component = "span"
						onClick   = { toggleDescription }
						title     = "..."
					/>
				)
			} */}
		</div>
	);
};

export default BroadcastDescription;
